import { render, staticRenderFns } from "./ApproachingTimeline.vue?vue&type=template&id=036643dc&scoped=true&"
import script from "./ApproachingTimeline.vue?vue&type=script&lang=js&"
export * from "./ApproachingTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ApproachingTimeline.vue?vue&type=style&index=0&id=036643dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036643dc",
  null
  
)

export default component.exports